import validate from "/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45to_45trailing_45slash_45global from "/nuxt-app/middleware/01.redirectToTrailingSlash.global.ts";
import _02_45feature_45flags_45global from "/nuxt-app/middleware/02.featureFlags.global.ts";
import _03_45validate_45country_45global from "/nuxt-app/middleware/03.validateCountry.global.ts";
import manifest_45route_45rule from "/nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45to_45trailing_45slash_45global,
  _02_45feature_45flags_45global,
  _03_45validate_45country_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}